import React, { createContext, useContext, useState, useEffect } from "react";
import { getAppUsersAll } from "../api/appUsersApi.js";
import { GOOGLE_CLIENT_ID } from "../config/env.js";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const login = (_userData) => {
    setUser(_userData);
    localStorage.setItem("user", JSON.stringify(_userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const storedUser = localStorage.getItem("user");
      setUser(storedUser ? JSON.parse(storedUser) : null);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // -------------------------------
  // Integración con Google One Tap
  // -------------------------------
  useEffect(() => {
    if (user) return; // No inicializar si ya hay usuario autenticado

    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleCallbackResponse,
      });

      // Muestra el prompt de Google One Tap
      window.google.accounts.id.prompt();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const loadUser = (decodedToken) => {
    getAppUsersAll()
      .then(response =>{
        const userList = response.data; 
        if (!Array.isArray(userList)) {
          throw new Error('La respuesta de usuarios no es un arreglo válido.');
        }
        const user = userList.find(u => u.email === decodedToken.email);
        if(user && user.is_active) {
          decodedToken.isAdmin = user.role.includes('admin');
          login(decodedToken);
        }else{
          console.error('User not found');
          decodedToken.isAdmin = null;
          login(decodedToken);
        }
      })
      .finally(() => {})
      .catch(error => console.error('Error fetching users:', error));
  };

  const handleCallbackResponse = (response) => {
    const decodedToken = parseJwt(response.credential);
    //login(decodedToken);
    loadUser(decodedToken);
  };

  // Decodifica un token JWT
  const parseJwt = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );
    return JSON.parse(jsonPayload);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
